import React from 'react';
import { MenuItem } from "@mui/material";
import { SortDirType } from "../../../../types/common/SortDirType";
import SortSelect from "../../../common/inputs/sortSelect/SortSelect";

export type SupplierInterchangeSortByType =
  | 'ACTIVITY_DATE'
  | 'ACTIVITY'
  | 'CONTAINER_NUMBER'
  | 'TRAILER_NUMBER'
  | 'CHASSIS_NUMBER'
  | 'CHASSIS_LICENSE_PLATE_NUMBER'
  | 'ASSET_SIZE'
  | 'DRIVER_FIRST_NAME'
  | 'DRIVER_LAST_NAME'
  | 'DRIVER_LICENSE_NUMBER'
  | 'SEAL_NUMBER'
  | 'ASSET_TYPE'
  | 'ORDER_NUMBER'
  | 'LOCATION_NAME'
  | 'CURRENT_INVENTORY';

type SupplierInterchangeSortSelectProps = {
  sortBy: SupplierInterchangeSortByType;
  onSortByChange: (value: SupplierInterchangeSortByType) => void;
  sortDir: SortDirType;
  onSortDirChange: (value: SortDirType) => void;
}

const SupplierInterchangeSortSelect = ({ sortBy, sortDir, onSortDirChange, onSortByChange }: SupplierInterchangeSortSelectProps) => {
  return <SortSelect<SupplierInterchangeSortByType>
    sortBy={sortBy}
    onSortByChange={onSortByChange}
    sortDir={sortDir}
    onSortDirChange={onSortDirChange}
    label={'Sort By'}
  >
    <MenuItem value={'ACTIVITY_DATE'}>Activity Date</MenuItem>
    <MenuItem value={'ACTIVITY'}>Activity</MenuItem>
    <MenuItem value={'CONTAINER_NUMBER'}>Container</MenuItem>
    <MenuItem value={'TRAILER_NUMBER'}>Trailer</MenuItem>
    <MenuItem value={'CHASSIS_NUMBER'}>Chassis</MenuItem>
    <MenuItem value={'CHASSIS_LICENSE_PLATE_NUMBER'}>Chassis License #</MenuItem>
    <MenuItem value={'ASSET_SIZE'}>Size</MenuItem>
    <MenuItem value={'DRIVER_FIRST_NAME'}>First Name (Driver)</MenuItem>
    <MenuItem value={'DRIVER_LAST_NAME'}>Last Name (Driver)</MenuItem>
    <MenuItem value={'DRIVER_LICENSE_NUMBER'}>License (Driver)</MenuItem>
    <MenuItem value={'SEAL_NUMBER'}>Seal</MenuItem>
    <MenuItem value={'ASSET_TYPE'}>Type</MenuItem>
    <MenuItem value={'ORDER_NUMBER'}>Booking</MenuItem>
    <MenuItem value={'LOCATION_NAME'}>Location</MenuItem>
    <MenuItem value={'CURRENT_INVENTORY'}>Inventory</MenuItem>
  </SortSelect>
}

export { SupplierInterchangeSortSelect };
